import { render, staticRenderFns } from "./BasicsWrapper.vue?vue&type=template&id=0a9dbbd2"
import script from "./BasicsWrapper.vue?vue&type=script&lang=js"
export * from "./BasicsWrapper.vue?vue&type=script&lang=js"
import style0 from "./BasicsWrapper.vue?vue&type=style&index=0&id=0a9dbbd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports